import React from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

const AnimatedElementStyles = {
  '@keyframes animate': {
    '0%': {
      opacity: 0,
      transform: 'translate(-15px, 0px)'
    },
    '50%': {
      opacity: 1
    },
    '100%': {
      opacity: 0,
      transform: 'translate(15px, 0px)'
    }
  },
  animation: 'animate 2s infinite',
  transform: 'translate(-50%, 0%)',
  ml: -3,
  '&:nth-of-type(2)': {
    animationDelay: '-0.2s'
  },
  '&:nth-of-type(3)': {
    animationDelay: '-0.4s'
  }
}

const AnimatedArrow = () => (
  <div>
    {[1, 2, 3].map((arrow) => (
      <ArrowForwardIosIcon
        key={arrow}
        color="success"
        fontSize="small"
        sx={AnimatedElementStyles}
      />
    ))}
  </div>
)

export default AnimatedArrow
